import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER =
  "paginationCampaignAnnounceRewardCustomer";
export const GET_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER =
  "getCampaignAnnounceRewardCustomer";
export const VERIFY_CAMPAIGN_RECEIPT_CODE = "verifyCampaignReceiptCode";
export const CREATE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER =
  "createCampaignAnnounceRewardCustomer";
export const UPDATE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER =
  "updateCampaignAnnounceRewardCustomer";
export const DELETE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER =
  "deleteCampaignAnnounceRewardCustomer";

// mutation types
export const SET_PAGINATION_CUSTOMER = "setPaginationCustomer";
export const SET_IS_CLEAR_PAGINATION_CUSTOMER = "setIsClearPaginationCustomer";
export const CLEAR_PAGINATION_CUSTOMER = "clearPaginationCustomer";

export default {
  state: {
    path: "campaign_announce_reward_customer",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: false,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [GET_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`, {
        params: payload.params
      });
    },
    [VERIFY_CAMPAIGN_RECEIPT_CODE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/verify_receipt_code`, {
        params: payload.params
      });
    },
    [CREATE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [DELETE_CAMPAIGN_ANNOUNCE_REWARD_CUSTOMER](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_PAGINATION_CUSTOMER](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION_CUSTOMER](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION_CUSTOMER](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: false,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
